<script>

import { Overlay } from '../../'

export default {
    name: 'TRIX',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'StdSquad', version: '1.0.0',
                desc: 'TRIX - Triple Exponential Average Oscillator',
                preset: {
                    name: 'TRIX $length $signal',
                    side: 'offchart',
                    settings: {
                        lineWidth: 1.5,
                        color: '#ff5722',
                        signalColor: '#2196f3'
                    }
                }
            }
        },
        use_for() { return ['TRIX'] },
        calc() {
            return {
                props: {
                    length: { def: 14, text: 'Length' },
                    signal: { def: 9, text: 'Signal' }
                },
                conf: { renderer: 'Splines' },
                update: `
                    let first = ema(close, length)
                    let second = ema(first, length)
                    let third = ema(second, length)
                    let rate = ts(third[1] ? 100 * (third[0] / third[1] - 1) : NaN)
                    let average = ema(rate, signal)
                    return [rate[0], average[0]]
                `
            }
        }
    }
}
</script>
